import React from 'react';
import classNames from 'classnames';

import css from './IconBedBreakfast.module.css';

export const IconBedBreakfast = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 50">
      <title />
      <g fill="none" fillRule="evenodd" stroke="#000" strokeWidth={2} transform="translate(1 1)">
        <rect width={4} height={48} rx={2} />
        <rect width={4} height={25} x={54} y={23} rx={2} />
        <path d="M4 31h50v8H4zM4 43h50" />
        <circle cx={30} cy={14} r={11} />
        <circle cx={30} cy={14} r={7} />
        <path d="M50 2.08V25a2 2 0 1 1-4 0V14h-1V8.33a9.01 9.01 0 0 1 3.38-7.03.995.995 0 0 1 1.62.78ZM14 10v15a2 2 0 1 1-4 0V10h4ZM50 14h-4M12 10V1" />
        <path d="M8 1v7a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V1" />
      </g>
    </svg>
  );
};

export default IconBedBreakfast;
